<template>
  <div>
    <!-- Content -->
    <div class="mb-5 container">
      <div class="flex flex-wrap gap-y-5 mb-5">
        <div class="w-full xl:w-9/12 xl:px-2 order-1">
          <div
            class="
              bg-grad bg-cover bg-no-repeat
              h-134
              xl:h-272
              flex
              items-end
              xl:items-center
              px-10
            "
          >
            <div class="flex-col w-full xl:w-3/5">
              <div
                class="
                  text-2xl
                  xl:text-4xl
                  font-EffraM
                  text-white text-start
                  mb-8
                  xl:mb-4
                "
                style="line-height: 100%"
              >
                {{ $t("homePage.msg_header_patient_side") }}
              </div>
              <button
                class="
                  bg-rosedok
                  w-full
                  py-4
                  border-0
                  rounded-cu
                  shadow
                  relative
                  uppercase
                  hidden
                  xl:flex
                  items-center
                  justify-evenly
                  cursor-pointer
                "
                @click="onClickDownload"
              >
                <span class="text-white px-2 flex items-center gap-x-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    viewBox="0 0 18 18"
                  >
                    <path
                      fill="#fff"
                      d="M8.718 5.416c-.657 0-1.674-.747-2.745-.72-1.413.018-2.71.82-3.438 2.088-1.467 2.547-.378 6.31 1.053 8.38.702 1.008 1.53 2.141 2.628 2.106 1.053-.046 1.449-.684 2.727-.684 1.269 0 1.629.684 2.745.657 1.134-.018 1.854-1.026 2.547-2.043.8-1.17 1.134-2.304 1.152-2.367-.027-.01-2.205-.847-2.232-3.367-.018-2.106 1.719-3.114 1.8-3.159-.99-1.449-2.511-1.61-3.042-1.647-1.386-.108-2.547.756-3.195.756zm2.34-2.124c.585-.702.972-1.683.864-2.655-.837.036-1.845.558-2.448 1.26-.54.621-1.008 1.62-.882 2.574.927.072 1.88-.477 2.466-1.179z"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    viewBox="0 0 18 18"
                  >
                    <path
                      fill="#fff"
                      d="M2.707 1.36L10.344 9l-7.636 7.64c-.136-.058-.252-.154-.334-.276-.081-.123-.124-.267-.124-.415V2.05c0-.147.043-.29.125-.413.08-.123.196-.219.332-.277zm8.167 8.17l1.727 1.727-8.203 4.75 6.476-6.477zm2.4-2.398l2.105 1.22c.113.065.208.16.273.274.066.113.1.243.1.374s-.034.26-.1.374c-.065.114-.16.209-.273.275l-2.106 1.22L11.405 9l1.869-1.868zM4.398 1.993l8.204 4.75-1.728 1.727-6.476-6.477z"
                    />
                  </svg>
                </span>
                <div class="flex-1 text-lg text-white font-EffraM">
                  {{ $t("homePage.app_download_patient") }}
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="w-full xl:w-1/4 xl:px-2 order-3 xl:order-2">
          <div class="bg-nnnnblue h-full rounded-cu pt-4 pb-8 flex flex-col">
            <div class="flex flex-row items-center gap-x-2 flex-grow">
              <img
                src="/svg/doctortools.svg"
                alt="Doctor tools"
                class="h-20 xl:h-32"
              />
              <div id="text" class="flex flex-col ml-5">
                <h3 class="font-EffraM text-2xl">
                  {{ $t("homePage.praticiens_sante") }}
                </h3>
                <ul class="list-disc">
                  <li class="font-EffraR flex flex-row items-center">
                    <div class="w-2 h-2 rounded-full bg-black mr-2"></div>
                    {{ $t("homePage.one_free_month") }}
                  </li>
                  <li class="font-EffraR flex flex-row items-center">
                    <div class="w-2 h-2 rounded-full bg-black mr-2"></div>
                    {{ $t("homePage.sans_engagement") }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="flex justify-center w-9/12 mx-auto mt-3 xl:mt-0">
              <button
                class="
                  bg-dokBlue-ultra
                  w-full
                  py-4
                  px-2
                  text-white
                  font-EffraR
                  text-2xl
                  border-0
                  rounded-lg
                  cursor-pointer
                  float-end
                "
                @click="
                  () => {
                    $router.push('/register');
                  }
                "
              >
                {{ $t("homePage.start_at_dok") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- CARD SEARCH -->
      <cardSearch class="mb-5" />
      <!-- END CARD SEARCH -->

      <div class="flex flex-row gap-x-3">
        <span
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            fill="none"
            viewBox="0 0 56 56"
          >
            <path
              fill="#000"
              d="M9.334 51.333c0-4.95 1.966-9.698 5.467-13.199 3.5-3.5 8.248-5.467 13.2-5.467 4.95 0 9.698 1.966 13.198 5.467 3.501 3.5 5.468 8.249 5.468 13.2H42c0-3.714-1.475-7.275-4.1-9.9-2.626-2.626-6.187-4.1-9.9-4.1s-7.274 1.474-9.9 4.1c-2.625 2.625-4.1 6.186-4.1 9.9H9.334zm18.666-21c-7.735 0-14-6.265-14-14s6.265-14 14-14 14 6.265 14 14-6.265 14-14 14zm0-4.666c5.157 0 9.334-4.177 9.334-9.334C37.334 11.177 33.157 7 28 7s-9.333 4.177-9.333 9.333c0 5.157 4.176 9.334 9.333 9.334z"
            />
          </svg>
        </span>
        <div class="flex flex-col mb-5">
          <h3 class="text-lg xl:text-3xl font-EffraM mb-2">
            {{ $t("homePage.pour_les_patient") }}
          </h3>
          <span class="text-base xl:text-lg font-EffraR">
            {{ $t("homePage.dok_vous_offre") }}
          </span>
        </div>
      </div>

      <div
        class="
          grid
          gap-y-5
          xl:gap-y-0
          gap-x-0
          md:gap-x-2
          xl:gap-x-3
          grid-cols-1
          md:grid-cols-2
          xl:grid-cols-4
          mb-5
        "
      >
        <div
          class="
            bg-rosDok-lighter
            flex flex-col
            gap-y-1
            items-center
            justify-center
          "
          style="height: 272px"
          v-for="(item, i) in forPatients"
          :key="i"
        >
          <div
            style="height: 92px; width: 92px"
            class="bg-transparent"
            v-html="item.icon"
          ></div>
          <div class="font-EffraM text-xl text-black">{{ item.title }}</div>
          <div class="h-20 font-EffraR px-5 text-black text-center">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>

    <div class="bg-nnnnblue py-5">
      <div class="xl:container">
        <div class="flex flex-row gap-x-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            fill="none"
            viewBox="0 0 56 56"
          >
            <path
              fill="#000"
              stroke="#000"
              d="M27.51 28c6.788 0 12.29-5.372 12.29-12S34.299 4 27.51 4c-6.79 0-12.292 5.372-12.292 12s5.503 12 12.292 12zm0-21c5.08 0 9.218 4.04 9.218 9s-4.139 9-9.218 9c-5.08 0-9.219-4.04-9.219-9s4.139-9 9.219-9zm8.997 24.01c-3.245-.094-4.254 1.49-8.997 1.49-4.734 0-5.743-1.584-8.988-1.49C11.569 31.205 6 36.765 6 43.6v7.65c0 .413.346.75.768.75h1.537c.422 0 .768-.337.768-.75V43.6c0-5.09 4.09-9.225 9.218-9.544v7.66c-2.218.646-3.84 2.653-3.84 5.034 0 2.897 2.41 5.25 5.377 5.25 2.967 0 5.377-2.353 5.377-5.25 0-2.381-1.623-4.388-3.841-5.034v-7.21c1.997.638 4.052.985 6.146.985 2.093 0 4.148-.347 6.145-.985v6.45c-2.708.703-4.609 3.235-4.609 6.056v2.738c0 .394.163.778.451 1.06l.99.965c.297.29.787.29 1.084 0l1.085-1.06c.298-.29.298-.768 0-1.059l-.547-.534V46.75c0-1.819 1.671-3.263 3.591-2.962 1.508.243 2.555 1.63 2.555 3.121v2.213l-.548.534c-.297.29-.297.769 0 1.06l1.085 1.059c.298.29.788.29 1.086 0l.989-.966c.288-.28.451-.665.451-1.059v-3c0-2.784-1.969-5.11-4.61-5.775v-6.91c5.129.32 9.22 4.454 9.22 9.544v7.641c0 .413.345.75.767.75h1.537c.422 0 .768-.337.768-.75V43.6c.02-6.834-5.55-12.394-12.493-12.59v0zM22.132 46.75c0 1.237-1.037 2.25-2.304 2.25-1.268 0-2.305-1.013-2.305-2.25s1.037-2.25 2.305-2.25c1.267 0 2.304 1.013 2.304 2.25z"
            />
          </svg>
          <div class="flex flex-col gap-y-1">
            <h3 class="font-EffraM text-4xl text-black">
              {{ $t("homePage.etes_vous_un_professionnel") }}
            </h3>
            <span class="text-base text-black font-EffraR">
              {{ $t("homePage.beneficiez_avantages") }}
            </span>
          </div>
        </div>
        <!----- Art Work ------>
        <div class="flex flex-col gap-y-6 justify-start mb-5 mt-5">
          <!-- <img :src="$t('homePage.artwork')" class="rounded-cu bg-opacity-10 cursor-pointer w-full xl:w-full" alt="dok.ma"/> -->
          <iframe
            class="h-[400px] w-full lg:h-[750px] px-5 md:px-0"
            src="https://www.youtube-nocookie.com/embed/-D0DVMxSdSc?rel=0"
            title="Présentation de la plateforme dok.ma"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            allowtransparency
            modestbranding="1"
            frameborder="0"
            playsinline
            autoplay="1"
          ></iframe>
          <div>
            <img src="/logos/pro/pro.png" alt="dok.ma" height="48" />
          </div>
        </div>
        <!---------- End Art Work -------------->
        <div
          class="flex flex-row items-center mb-5"
          :class="
            $defaultLang === 'ar'
              ? 'justify-start lg:justify-between'
              : 'justify-end lg:justify-between'
          "
        >
          <img
            src="/art/maskgroup.png"
            srcset="/art/maskgroup@2x.png 2x, /art/maskgroup@3x.png 3x"
            class="block xl:hidden"
            alt="Êtes-vous un professionnel de la sant"
          />
        </div>
        <div
          class="
            grid
            gap-4
            grid-cols-1
            xl:grid-cols-2
            md:items-start
            px-3
            xl:px-0
          "
        >
          <div class="flex flex-col order-last xl:order-first">
            <functionProDok />

            <button
              class="
                bg-dokBlue-ultra
                w-full
                py-4
                px-2
                text-white
                font-EffraR
                text-lg
                border-0
                rounded-lg
                mb-5
                cursor-pointer
              "
              @click="
                () => {
                  $router.push('/register');
                }
              "
            >
              {{ $t("homePage.essayez_pro_free") }}
            </button>

            <ul>
              <li class="text-base text-gray-700 py-1 font-EffraR">
                <i class="fas fa-check mr-2"></i>
                {{ $t("homePage.one_free_month") }}
              </li>
              <li class="text-base text-gray-700 py-1 font-EffraR">
                <i class="fas fa-check mr-2"></i>
                {{ $t("homePage.abonnement_moment") }}
              </li>
            </ul>
          </div>
          <div
            class="order-first xl:order-last hidden xl:block"
            :style="
              $defaultLang === 'ar'
                ? 'padding-right: 30%;'
                : 'padding-left: 30%;'
            "
          >
            <img
              src="/art/dokfe.png"
              srcset="/art/dokfe@2x.png 2x, /art/dokfe@3x.png 3x"
              alt="Êtes-vous un professionnel de la sant"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- End Content -->

    <!-- Footer -->
    <footer-layout :down-load-app="true"></footer-layout>
    <!-- End Footer -->
  </div>
</template>

<style lang="scss" scoped>
.scroll-bottom {
  &::-webkit-scrollbar {
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #f8f8f8;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #2e6bff;
    border-radius: 2px;
    border: 1px solid #ffeff0;
  }
}
</style>

<script>
const downloadApp = () =>
  import("@/layouts/home/layouts/navbar/layouts/downloadApp");
const cardSearch = () => import("./layouts/cardSearch");
const footerLayout = () => import("./layouts/footer");
const functionProDok = () =>
  import("@/views/global-components/functionsDokPro");

export default {
  data() {
    return {
      forPatients: [
        {
          icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" fill="none" viewBox="0 0 92 92">
                <path fill="#2C75FF" stroke="#297AFB" stroke-width="2.6" d="M57.526 40.41H33.295c-.478 0-.866.388-.866.866s.388.865.866.865h24.23c.479 0 .866-.387.866-.865s-.387-.865-.865-.865zM61.852 46.468H33.296c-.478 0-.866.388-.866.866s.388.865.866.865h28.557c.479 0 .866-.387.866-.865s-.388-.866-.866-.866z"/>
                <path fill="#FD5B68" stroke="#FD5B68" stroke-width="2.3" d="M72.048 55.602c-.586-.702-1.388-1.19-2.281-1.388v-34.51c0-.187-.074-.366-.206-.498S69.25 19 69.064 19H27.3c-.187 0-.366.074-.498.206-.131.132-.206.31-.206.497v23.474h-3.694c-1.035 0-2.027.412-2.759 1.144-.731.732-1.143 1.724-1.144 2.759v27.833c0 .013.003.024.003.035-.002.094.014.187.047.275.034.087.085.166.15.233.066.067.144.12.23.157.087.036.18.055.273.054h49.425c.165 0 .323-.057.45-.162.126-.105.211-.25.242-.412l3.057-16.345c.102-.553.08-1.122-.063-1.666-.143-.544-.405-1.049-.766-1.48zM68.36 20.406v33.7H28.005v-33.7H68.36zM22.904 44.583h3.694v9.523h-.246c-2.006 0-3.718 1.369-4.07 3.253l-1.875 10.022V47.08c.001-.662.264-1.297.732-1.765.468-.468 1.103-.731 1.765-.732zm48.592 13.906l-2.95 15.772H20.55l3.113-16.643c.228-1.22 1.359-2.105 2.688-2.105h42.456c.41-.005.817.081 1.19.252.373.171.704.422.969.736.231.27.399.59.49.934.092.344.105.704.039 1.054z"/>
                <path fill="#FD5B68" stroke="#FD5B68" stroke-width="1.3" d="M32.084 33.11h2.023v2.024c0 .186.074.365.206.497s.31.206.497.206h4.722c.187 0 .365-.074.497-.206s.206-.31.206-.497V33.11h2.023c.187 0 .365-.074.497-.206s.206-.31.206-.497v-4.722c0-.187-.074-.366-.206-.497-.132-.132-.31-.206-.497-.206h-2.023V24.96c0-.187-.074-.366-.206-.498-.132-.131-.31-.206-.497-.206H34.81c-.186 0-.365.075-.497.206-.132.132-.206.311-.206.498v2.023h-2.023c-.186 0-.365.074-.497.206-.132.131-.206.31-.206.497v4.722c0 .186.074.365.206.497s.31.206.497.206zm.703-4.721h2.023c.187 0 .366-.074.497-.206.132-.132.206-.31.206-.497v-2.023h3.316v2.023c0 .186.074.365.206.497s.31.206.497.206h2.023v3.316h-2.023c-.186 0-.365.074-.497.205-.132.132-.206.311-.206.498v2.023h-3.316v-2.023c0-.187-.074-.366-.206-.498-.131-.131-.31-.206-.497-.206h-2.023V28.39z"/>
            </svg>
            `,
          title: this.$t("homePage.pack.one.title"),
          content: this.$t("homePage.pack.one.content"),
        },
        {
          icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" fill="none" viewBox="0 0 92 92">
              <path fill="#FD5B68" d="M66.25 21.686h-1.81c0-.053.022-.101.017-.155-.05-.442-.268-.848-.61-1.133-.343-.284-.782-.425-1.226-.393-1.275.123-2.456.724-3.307 1.681H49.16c0-.053.021-.101.016-.155-.047-.443-.265-.85-.607-1.136-.343-.285-.784-.425-1.228-.39-1.275.124-2.457.724-3.308 1.681h-9.87c.008-.051.014-.103.017-.155-.048-.443-.266-.85-.609-1.135-.343-.285-.783-.425-1.227-.39-1.275.122-2.456.723-3.307 1.68H25.75c-1.79.002-3.505.714-4.77 1.98-1.266 1.265-1.978 2.98-1.98 4.77v37.125c.002 1.79.714 3.505 1.98 4.77 1.265 1.266 2.98 1.978 4.77 1.98h40.5c1.79-.002 3.505-.714 4.77-1.98 1.266-1.265 1.978-2.98 1.98-4.77V28.436c-.002-1.79-.714-3.505-1.98-4.77-1.265-1.266-2.98-1.978-4.77-1.98zm3.375 43.875c0 .895-.356 1.754-.989 2.386-.632.633-1.49.99-2.386.99h-40.5c-.895 0-1.754-.356-2.387-.99-.632-.632-.988-1.49-.988-2.386V36.874h33.75c.448 0 .877-.178 1.193-.495.317-.316.495-.745.495-1.193 0-.447-.178-.877-.495-1.193-.316-.317-.745-.494-1.193-.494h-33.75v-5.063c0-.895.356-1.753.988-2.386.633-.633 1.492-.989 2.387-.989h1.975v.003c.008 1.29.504 2.528 1.388 3.466.884.938 2.09 1.506 3.377 1.59.036.004.073.004.109.004.438 0 .86-.17 1.175-.475.315-.305.5-.72.514-1.159.014-.438-.143-.864-.438-1.189-.295-.324-.705-.521-1.142-.55-.43-.03-.834-.22-1.132-.533-.297-.313-.467-.726-.476-1.157h11.618v.003c.008 1.29.504 2.528 1.389 3.466.884.938 2.091 1.506 3.378 1.59.036.004.073.004.112.004.438 0 .86-.171 1.174-.476.314-.306.498-.721.512-1.16.013-.437-.144-.863-.439-1.187-.294-.325-.704-.521-1.141-.55-.431-.03-.835-.22-1.133-.533-.297-.313-.468-.725-.478-1.157h11.909c.005 1.29.5 2.53 1.385 3.47.885.938 2.093 1.507 3.38 1.59.036.003.073.003.112.003.439 0 .86-.172 1.174-.477.314-.305.498-.72.512-1.158.013-.438-.144-.864-.439-1.189-.295-.324-.704-.52-1.141-.548-.431-.03-.835-.22-1.132-.534-.298-.313-.467-.725-.476-1.157h4.874c.895 0 1.754.356 2.386.989.633.633.989 1.491.989 2.386V33.5h-6.75c-.448 0-.877.177-1.193.494-.317.316-.495.745-.495 1.193 0 .448.178.877.495 1.193.316.317.745.495 1.193.495h6.75V65.56z"/>
              <path fill="#297AFB" d="M54 46.561c-.943-.002-1.856.324-2.578.921-.721.597-1.205 1.427-1.364 2.341-.16.915.014 1.855.492 2.656.477.8 1.227 1.407 2.117 1.715v.242c0 1.392-.562 2.728-1.563 3.712-1 .985-2.356 1.538-3.77 1.538-1.415 0-2.772-.553-3.772-1.538-1-.984-1.562-2.32-1.562-3.712v-.133c1.505-.304 2.857-1.11 3.828-2.28.972-1.172 1.504-2.637 1.505-4.15v-5.25c0-.348-.14-.681-.39-.927-.25-.247-.59-.385-.943-.385h-2.667c-.353 0-.692.138-.942.385-.25.246-.391.58-.391.928 0 .348.14.681.39.928.25.246.59.384.943.384h1.334v3.938c0 1.044-.422 2.045-1.172 2.784-.75.738-1.767 1.153-2.828 1.153s-2.079-.415-2.829-1.153c-.75-.739-1.171-1.74-1.171-2.785v-3.937H38c.354 0 .693-.138.943-.384s.39-.58.39-.928c0-.349-.14-.682-.39-.928-.25-.247-.59-.385-.943-.385h-2.667c-.353 0-.692.138-.942.385-.25.246-.391.58-.391.928v5.25c.002 1.512.533 2.977 1.505 4.148.971 1.172 2.323 1.977 3.828 2.281v.133c0 2.089.843 4.092 2.343 5.569 1.5 1.476 3.536 2.306 5.657 2.306 2.122 0 4.157-.83 5.657-2.306 1.5-1.477 2.343-3.48 2.343-5.569v-.242c.89-.308 1.64-.915 2.117-1.715.478-.8.652-1.741.492-2.656-.16-.914-.643-1.744-1.365-2.34-.721-.598-1.634-.924-2.577-.922zm0 5.25c-.264 0-.522-.077-.74-.221-.22-.144-.391-.35-.492-.59-.1-.239-.127-.503-.076-.758.052-.254.179-.488.365-.671.187-.184.424-.31.683-.36.258-.05.526-.024.77.075.244.1.452.267.599.483.146.216.224.47.224.73 0 .347-.141.68-.391.927-.25.246-.589.384-.942.385z"/>
            </svg>
            `,
          title: this.$t("homePage.pack.three.title"),
          content: this.$t("homePage.pack.three.content"),
        },
        {
          icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" fill="none" viewBox="0 0 92 92">
                <path fill="#297AFB" stroke="#297AFB" stroke-width=".4" d="M47.917 41.25H45.75v-2.167c0-.287-.114-.563-.317-.766-.203-.203-.479-.317-.766-.317h-4.334c-.287 0-.563.114-.766.317-.203.203-.317.479-.317.766v2.167h-2.167c-.287 0-.563.114-.766.317-.203.203-.317.479-.317.766v4.334c0 .287.114.563.317.766.203.203.479.317.766.317h2.167v2.167c0 .287.114.563.317.766.203.203.479.317.766.317h4.334c.287 0 .563-.114.766-.317.203-.203.317-.479.317-.766V47.75h2.167c.287 0 .563-.114.766-.317.203-.203.317-.479.317-.766v-4.334c0-.287-.114-.563-.317-.766-.203-.203-.479-.317-.766-.317zm-1.084 4.333h-2.166c-.288 0-.563.114-.766.318-.204.203-.318.478-.318.766v2.166h-2.166v-2.166c0-.288-.114-.563-.318-.766-.203-.204-.478-.318-.766-.318h-2.166v-2.166h2.166c.288 0 .563-.114.766-.318.204-.203.318-.478.318-.766v-2.166h2.166v2.166c0 .288.114.563.318.766.203.204.478.318.766.318h2.166v2.166z"/>
                <path fill="#FD5B68" stroke="#FD5B68" d="M55.5 62c-1.483 0-2.933.47-4.167 1.348-1.233.88-2.194 2.129-2.762 3.59-.568 1.462-.716 3.07-.427 4.623.29 1.552 1.004 2.977 2.053 4.096 1.049 1.119 2.385 1.88 3.84 2.19 1.455.308 2.963.15 4.333-.456s2.542-1.63 3.366-2.946C62.56 73.129 63 71.582 63 70c-.002-2.121-.793-4.154-2.2-5.654-1.405-1.5-3.312-2.344-5.3-2.346zm0 13.714c-1.06 0-2.095-.335-2.976-.963-.881-.628-1.568-1.52-1.973-2.564-.406-1.044-.512-2.193-.305-3.302.206-1.108.717-2.127 1.466-2.926.75-.799 1.704-1.343 2.743-1.564 1.04-.22 2.116-.107 3.095.326.979.432 1.816 1.165 2.404 2.104.589.94.903 2.045.903 3.175-.002 1.515-.566 2.967-1.57 4.039-1.005 1.07-2.367 1.674-3.787 1.675z"/>
                <path fill="#FD5B68" stroke="#FD5B68" d="M60 69h-9v2h9v-2zM52.09 27.631l-1.28-.374c-.677-.198-1.272-.615-1.695-1.189-.424-.573-.653-1.272-.654-1.99V20.8h1.078c.285 0 .559-.116.761-.322.202-.207.315-.486.315-.778v-6.6c0-.292-.113-.572-.315-.778-.202-.206-.476-.322-.761-.322H34.46c-.285 0-.559.116-.761.322-.202.207-.315.486-.315.778v6.6c0 .292.113.572.315.778.202.206.476.322.761.322h1.078v3.278c-.001.718-.23 1.417-.654 1.99-.423.574-1.018.991-1.694 1.189l-1.282.374c-1.124.331-2.113 1.026-2.818 1.98-.704.954-1.088 2.116-1.091 3.311V59.3c.003.874.344 1.712.95 2.33.604.619 1.425.967 2.28.97h2.24c-.169 1.184-.065 2.393.303 3.529.369 1.136.992 2.169 1.82 3.016.02.022.042.033.064.055h-3.35c-1.142 0-2.238.463-3.045 1.289C28.454 71.314 28 72.433 28 73.6c0 1.167.454 2.286 1.262 3.111.808.825 1.903 1.289 3.046 1.289h8.615c.833.003 1.65-.241 2.35-.704.699-.463 1.251-1.123 1.59-1.901.337-.778.446-1.64.313-2.48-.134-.84-.504-1.623-1.065-2.252.797-.372 1.523-.886 2.143-1.518.828-.847 1.45-1.88 1.819-3.016.368-1.136.472-2.345.302-3.529h4.394c.856-.003 1.677-.351 2.282-.97.605-.618.946-1.456.949-2.33V32.922c-.004-1.195-.386-2.357-1.091-3.311-.705-.954-1.694-1.649-2.818-1.98zM35.539 75.8h-3.23c-.572 0-1.12-.232-1.523-.644-.404-.413-.631-.973-.631-1.556 0-.584.227-1.143.63-1.556.405-.412.953-.644 1.524-.644h3.23v4.4zm0-61.6h12.924v4.4H35.538v-4.4zm5.385 61.6h-3.23v-4.4h3.23c.571 0 1.12.232 1.523.644.404.413.63.972.63 1.556 0 .583-.226 1.143-.63 1.556-.404.412-.952.644-1.523.644zm4.49-9.064l-4.49-4.598-1.53 1.562 4.502 4.587c-1.035.701-2.276 1.015-3.512.888-1.236-.127-2.392-.686-3.27-1.583-.878-.898-1.426-2.078-1.55-3.34-.124-1.263.183-2.53.87-3.588l1.442 1.485 1.53-1.562-1.454-1.474c1.035-.701 2.276-1.015 3.512-.888 1.236.127 2.392.686 3.27 1.583.879.898 1.426 2.078 1.55 3.34.124 1.263-.183 2.53-.87 3.588zm8.433-7.436c0 .292-.113.572-.315.778-.202.206-.476.322-.762.322h-5.04c-.371-.794-.87-1.519-1.475-2.145-.7-.715-1.531-1.282-2.446-1.67-.915-.386-1.895-.586-2.885-.586-.99 0-1.97.2-2.885.587-.915.387-1.746.954-2.446 1.669-.605.626-1.104 1.351-1.475 2.145H31.23c-.286 0-.56-.116-.762-.322-.202-.207-.315-.486-.315-.778V56h23.692v3.3zm0-5.5H30.154V36.2h23.692v17.6zm0-19.8H30.154v-1.078c0-.718.23-1.417.653-1.99.424-.574 1.019-.991 1.695-1.189l1.281-.374c1.124-.331 2.113-1.026 2.818-1.98.705-.954 1.088-2.116 1.091-3.311V20.8h8.616v3.278c.003 1.195.386 2.357 1.091 3.31.705.955 1.694 1.65 2.818 1.981l1.282.374c.675.198 1.27.615 1.694 1.189.423.573.653 1.272.653 1.99V34z"/>
            </svg>
            `,
          title: this.$t("homePage.pack.two.title"),
          content: this.$t("homePage.pack.two.content"),
        },
        {
          icon: `
              <svg xmlns="http://www.w3.org/2000/svg" width="92" height="92" fill="none" viewBox="0 0 92 92">
                  <path fill="#FD5B68" stroke="#FD5B68" d="M46.833 18.747c-.246.165-.536.253-.833.253-.398 0-.78-.158-1.06-.44-.282-.28-.44-.662-.44-1.06 0-.297.088-.587.253-.833.165-.247.399-.44.673-.553.274-.113.576-.143.867-.085.29.058.558.2.768.41.21.21.352.477.41.768.058.291.028.593-.085.867-.114.274-.306.508-.553.673z"/>
                  <path fill="#FD5B68" d="M63 73V19c0-1.326-.527-2.598-1.465-3.536C60.599 14.527 59.326 14 58 14H34c-1.326 0-2.598.527-3.535 1.464C29.527 16.402 29 17.674 29 19v4c-.265 0-.52.105-.707.293-.188.187-.293.442-.293.707v4c0 .265.105.52.293.707.187.188.442.293.707.293v2c-.265 0-.52.105-.707.293-.188.187-.293.442-.293.707v4c0 .265.105.52.293.707.187.188.442.293.707.293v36c0 1.326.527 2.598 1.465 3.535C31.402 77.474 32.674 78 34 78h24c1.326 0 2.598-.527 3.535-1.465C62.474 75.599 63 74.326 63 73zm-32 0V17.5h30V73c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879H34c-.796 0-1.559-.316-2.121-.879C31.316 74.56 31 73.796 31 73z"/>
                  <path stroke="#FD5B68" d="M61 17.5c-.12-.706-.487-.346-1.038-.805-.55-.459-1.246-.705-1.962-.695H34c-.708.002-1.392.254-1.931.711-.54.458-.901 1.091-1.019 1.789l-.05-1m30 0V73c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879H34c-.796 0-1.559-.316-2.121-.879C31.316 74.56 31 73.796 31 73V17.5m30 0H31M63 73V19c0-1.326-.527-2.598-1.465-3.536C60.599 14.527 59.326 14 58 14H34c-1.326 0-2.598.527-3.535 1.464C29.527 16.402 29 17.674 29 19v4c-.265 0-.52.105-.707.293-.188.187-.293.442-.293.707v4c0 .265.105.52.293.707.187.188.442.293.707.293v2c-.265 0-.52.105-.707.293-.188.187-.293.442-.293.707v4c0 .265.105.52.293.707.187.188.442.293.707.293v36c0 1.326.527 2.598 1.465 3.535C31.402 77.474 32.674 78 34 78h24c1.326 0 2.598-.527 3.535-1.465C62.474 75.599 63 74.326 63 73z"/>
                  <path fill="#297AFB" d="M37.444 50h12.223c.604.004 1.188-.213 1.64-.607.451-.395.738-.94.804-1.529l1.785.756c.294.119.61.18.928.18.435-.012.858-.14 1.223-.372.288-.174.527-.418.694-.707.166-.29.256-.616.259-.949v-5.544c0-.33-.086-.655-.249-.945-.162-.29-.396-.534-.68-.711-.322-.207-.692-.333-1.075-.366-.384-.034-.77.026-1.125.174l-1.76.756c-.066-.59-.353-1.134-.804-1.529-.452-.394-1.036-.61-1.64-.607H37.444c-.648 0-1.27.253-1.728.703-.459.45-.716 1.06-.716 1.697v7.2c0 .636.258 1.247.716 1.697.458.45 1.08.703 1.728.703zm17.112-8.4v4.644l-2.445-1.032v-2.484l2.445-1.128zm-17.112-1.2h12.223v7.2H37.444v-7.2z"/>
              </svg>
            `,
          title: this.$t("homePage.pack.foor.title"),
          content: this.$t("homePage.pack.foor.content"),
        },
      ],
    };
  },
  components: {
    downloadApp,
    cardSearch,
    footerLayout,
    functionProDok,
  },
  methods: {
    onClickDownload() {
      let elementDownload = document.getElementById("downloadAppFooter");
      elementDownload.scrollIntoView();

      this.gtmSent();

      if (elementDownload.classList.contains("animate__bounceIn")) {
        elementDownload.classList.remove("animate__bounceIn");
        setTimeout(() => {
          elementDownload.classList.add("animate__bounceIn");
        }, 200);

        return;
      }

      elementDownload.classList.add("animate__bounceIn");
    },
    gtmSent() {
      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: "download",
        action: "click",
        label: "Download mobile App",
        value: 1,
        noninteraction: false, // Optional
      });
    },
  },
};
</script>
